import React, { Component } from "react";

export default class AvatarFetching extends Component {
  render() {
    return (
      <div className="user-fetching author">
        <div className="author-avatar" />
        <div className="author-header">
          <div className="group-titles">
            <h3 className="gradiant" />
            <h4 className="gradiant" />
          </div>
          <h5>
            <span className="gradiant" />
          </h5>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/AvatarFetching.js